import { render, staticRenderFns } from "./editProject.vue?vue&type=template&id=4c6436b1&scoped=true"
import script from "./editProject.vue?vue&type=script&lang=js"
export * from "./editProject.vue?vue&type=script&lang=js"
import style0 from "./editProject.vue?vue&type=style&index=0&id=4c6436b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6436b1",
  null
  
)

export default component.exports